import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
import HeaderTitle from "../HeaderTitle";
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import ContactButton from "../ContactButton";
import FeaturedContent from "../FeaturedContent";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
export default function Blog({ blog = {}, consultant = {}, filtered_blogs = [], className }) {

  const [basePath, setBasePath] = useState('');

  useEffect(() => {
    const baseUrl = window.location.protocol + "//" + window.location.host;
    setBasePath(baseUrl);
  }, []);

  const router = useRouter();
  const pathName = basePath + router.asPath;
  const nonBlogs = ['Events', 'Podcast'];

  function formatDate(date) {
    const dateObject = new Date(date);

    if (isNaN(dateObject)) {
      return '';
    }

    const day = dateObject.getDate();
    const month = dateObject.toLocaleString('en-US', { month: 'long' });
    const year = dateObject.getFullYear();

    const outputDate = `${day} ${month} ${year}`;

    return outputDate
  }

  function handleRedirectDownload(url) {
    window.open(url, '_blank');
    window.location.href = '/thank-you';
  }

  return (
    <>
      <div className={clsx(className, classes.blog)}>
        <div className={classes.blog_content}>
          <div className={classes.header}>
            <img className={classes.image} src={blog.image} alt={blog.alt_text || blog.title}></img>
            <h1 className={classes.title}>{blog.title}</h1>
            {!['Events'].includes(blog.category) &&
              <div className={classes.time}>
                {
                  !nonBlogs.includes(blog.category) && blog.category !== "Reports" &&
                  <div className={classes.duration}><img src="/icons/time-clock.png" alt="time-clock" />{`${blog.minutes ?? 5} min read`}</div>
                }
                {
                  blog.publish_date ? <div className={classes.date}><img src="/icons/calendar.png" alt="calendar" />{formatDate(blog.publish_date)}</div> : <></>
                }
                {
                  blog.updated_at && new Date(blog.publish_date).toDateString() !== new Date(blog.updated_at).toDateString() ? (
                    <div className={classes.date}>
                      <span className={classes.label}>Updated:</span>
                      {formatDate(blog.updated_at)}
                    </div>
                  ) : <></>
                }
              </div>
            }
          </div>
          <div className={classes.description}>
            {
              blog?.formid &&
              <SourceFlowForm
                onSubmitDone={() => handleRedirectDownload(blog?.report)}
                formId={blog?.formid}
              />
            }
            <div dangerouslySetInnerHTML={{ __html: blog?.body }} />
          </div>
        </div>

        <div className={classes.additional_col}>

          {
            !nonBlogs.includes(blog.category) &&
            <div className={classes.consultant_card}>
              <div className={classes.sharing}>
                <div className={classes.title}>{blog.category === "Reports" ? "share now" : "share this blog"}</div>
                <div className={classes.socials}>
                  <a href={"https://www.facebook.com/sharer/sharer.php?u=" + pathName} target="_blank" rel="nofollow" className={classes.icon}><img src="/icons/facebook_borderless.png" alt="facebook" /></a>
                  <a href={"https://www.linkedin.com/sharing/share-offsite/?url=" + pathName} target="_blank" rel="nofollow" className={classes.icon}><img src="/icons/linkedin_borderless.png" alt="linkedin" /></a>
                  <a href={`mailto:?body=${encodeURIComponent(pathName)}`} target="_blank" rel="nofollow" className={classes.icon}><img src="/icons/envelope_borderless.png" alt="envelope" /></a>
                  <a href={"https://wa.me/?text=Check%20out%20this%20link:%20" + pathName} target="_blank" rel="nofollow" className={classes.icon}><img src="/icons/whatsapp_borderless.png" alt="whatsapp" /></a>
                </div>
              </div>

              {consultant.name && consultant.name !== 'Xcede' &&
                <div className={classes.consultant}>
                  <div className={classes.title}>written by</div>
                  <div className={classes.profile}>
                    <img className={classes.profile_image} src={consultant.profile_image ?? '/profile_placeholder.jpg'} alt={consultant.name} />
                    <div className={classes.details}>
                      <Link href={"/consultant/" + consultant.url_slug} passHref>
                        <h4 className={classes.name}>{consultant.name}</h4>
                      </Link>
                      <div className={classes.description}>{consultant.description}</div>
                    </div>
                    <div className={classes.contact}>
                      <ContactButton href={"mailto:" + consultant.email} icon={"/icons/envelope.png"} alt="envelope"></ContactButton>
                      <ContactButton href={"tel:" + consultant.phone} icon={"/icons/call.png"} alt="call"></ContactButton>
                      <ContactButton href={consultant.linkedin} icon={"/icons/linkedin.png"} alt="linkedin"></ContactButton>
                    </div>
                  </div>
                </div>
              }

            </div>
          }

          {
            blog.category === 'Blogs' && filtered_blogs.length > 0 &&
            <div className={classes.latest_blogs}>
              <div style={{ width: 'fit-content' }}>
                <HeaderTitle title="latest blogs" fontSize={'28px'} lineHeight={'34px'} />
              </div>
              <div className={classes.listing}>
                {filtered_blogs.map((blog, key) => (
                  <div className={classes.item} key={key}>
                    <Link href={"/blog/" + blog.url_slug}>
                      <div className={classes.header}>
                        <div className={classes.tag}>{blog.category}</div>
                        <div className={classes.duration}><img src="/icons/time-clock.png" alt="time-clock" />{`${blog.minutes ?? 5} min read`}</div>
                      </div>
                      <div className={classes.title}>
                        {blog.title}
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          }

          {
            blog.featuredcontent &&
            <div className={classes.featured_content}>
              <FeaturedContent link={blog.featuredcontent} />
            </div>
          }

          <div className={classes.survey}>
            <span className={classes.title}>XCEDE'S 2023 UK SALARY GUIDE</span>
            <span className={classes.description}>Explore the biggest salary trends and insights from 2022 and 2023 in Xcede’s UK 2023 Salary Survey.</span>
            <Link href="https://www.xcede.com/explore-our-2023-salary-survey" passHref>
              <button className={classes.download_btn}><img src="/icons/download_arrow.png" alt="download-arrow" />Download Now</button>
            </Link>
          </div>

        </div>
      </div>
    </>
  );
}

Blog.defaultProps = {
  className: "",
};
